export default "__VITE_ASSET__b5af048d__"